export default __webpack_public_path__ + "static/media/transfer-epoint-step4.9d51bf77.png";